import { render } from "./pagination.vue?vue&type=template&id=372d47dc&ts=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__